<template>
    <div class="videoBox">
      <div class="dragArea" v-bind:class="{ dragFixed: !delivered }">
        <span v-if="!delivered" class="material-icons">drag_indicator</span>
        <span v-else class="material-icons">check_circle</span>
      </div>
      <div class="deliverableDetails">
        <template v-if="editMode">
          <div class="deliverableCode">
            <select class="deliverableDirection" v-model="modelValues.direction">
              <option v-for="direction in referencedArray('direction')" v-bind:value="direction.id" v-bind:key="direction.id">
                {{ direction.name }}
              </option>
            </select>
            <input class="deliverableNumber" type="number" v-model.number="modelValues.number" placeholder="102"/>
          </div>
        </template>
        <template v-else>
          <span v-if="videoTitle">{{videoTitle}}</span>
          <span v-else class="deliverableCodePlaceholder router-link-active" v-on:click="engageEditMode">Add deliverable details</span>
        </template>
        <div class="deliverableDescription">
          <textarea v-if="editMode" v-model="modelValues.description"/>
          <div v-else>
            <span v-if="video.description" class="deliverableDescriptionText">{{video.description}}</span>
            <span v-else class="deliverableDescriptionPlaceholder router-link-active" v-on:click="engageEditMode">Add a description</span>
          </div>
        </div>
      </div>
      <div class="deliverableEditControls">
        <span class="material-icons icon-button" v-if="!editMode" v-on:click="engageEditMode">edit</span>
        <span class="material-icons icon-button" v-if="!editMode" v-on:click="deleteDeliverable">delete</span>
        <span class="material-icons icon-button" v-if="editMode" v-on:click="cancelEdit">cancel</span>
        <span class="material-icons icon-button" v-if="updateAvailable" v-on:click="saveChanges">save</span>
      </div>
    </div>
</template>

<script>

export default {
  name: 'VideoQueueRow',
  props: {
    video: Object
  },
  data () {
    var dataObj = {
      editMode: false
    }
    dataObj.fieldTypes = {
      number: "number",
      direction: "reference",
      description: "string"
    }
    dataObj.modelValues = {
      number: this.video.number ? this.video.number : null,
      direction: this.video.direction ? this.video.direction.id : null,
      description: this.video.description ? this.video.description : null
    }
    return dataObj
  },
  computed: {
    updateAvailable() {
      if (Object.keys(this.updateObj).length > 0) {
        return true
      } else {
        return false
      }
    },
    delivered() {
      if (this.video.deliveryDate) {
        return true
      } else {
        return false
      }
    },
    videoTitle () {
      var videoNumber = this.video.number ? this.video.number : ""
      if (this.video.direction && this.$store.state.directionCollection[this.video.direction.id]) {
        return this.$store.state.directionCollection[this.video.direction.id].name + " " + videoNumber
      } else {
        return null
      }
    },
    updateObj(){
      var modelValues = this.modelValues
      var fieldTypes = this.fieldTypes
      var initialValues = this.video
      var updateObj = {}
      Object.keys(modelValues).forEach((field)=>{
        var initialValue
        if (initialValues[field] != undefined) {
          if (fieldTypes[field] === "reference") {
            initialValue = initialValues[field].id
          } else {
            initialValue = initialValues[field]
          }
        } else {
          initialValue = null;
        }
        if (initialValue != modelValues[field]) {
          if (fieldTypes[field] === "reference") {
            updateObj[field] = this.$store.state.directionCollection[modelValues[field]].ref
          } else {
            updateObj[field] = modelValues[field]
          }
        }
      })
      return updateObj
    }
  },
  methods: {
    deleteDeliverable (){
      var videoTitle = this.videoTitle ? this.videoTitle : "this deliverable"
      var storeVar = this.$store
      var deliverableRef = this.video.ref
      this.$dialog.confirm(`Are you sure you want to delete ${videoTitle}?`).then(function() {
        storeVar.dispatch('deleteFirebaseRecord',deliverableRef)
      }).catch(function() {
      });
    },
    engageEditMode() {
      this.editMode = true
    },
    referencedArray (collection) {
      return this.$store.getters[`${collection}Array`]
    },
    cancelEdit() {
      this.modelValues = {
        number: this.video.number ? this.video.number : null,
        direction: this.video.direction ? this.video.direction.id : null,
        description: this.video.description ? this.video.description : null
      }
      this.editMode = false
    },
    saveChanges() {
      this.$store.dispatch('updateFirebaseRecord',[this.video.ref,this.updateObj])
      this.editMode = false
    }
  }
}
</script>

<style lang="scss" scoped>
.videoBox {
  user-select: none;
  display: flex;
  width: 325px;
  border: 1px solid #2E303A;
  padding: 10px;
  border-radius: 5px;
  margin: 10px;
  background-color: #333746;
  &.ghost {
    opacity: .5;
    background-color: #73A9F7;
  }
  .deliverableEditControls {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 5px;
    }
  }
  .dragArea {
    display: flex;
    align-items: center;
    padding-right: 10px;
    &.dragFixed {
      cursor: grab;
    }
    &:not(.dragFixed) {
      cursor: not-allowed;
    }
  }
  .deliverableCode {
    input {
      display: inline-block;
    }
    .deliverableDirection {
      width: 100px;
      margin-right: 7px;
    }
    .deliverableNumber {
      width: 100px;
    }

  }
  .deliverableCodePlaceholder {
    color: #FFFFFF30;
  }
  .deliverableDescription {
    width: 207px;
    height: 50px;
    textarea {
      margin-top: 7px;
      width: 100%;
      height: 100%;
    }
    .deliverableDescriptionText {
      color: #FFFFFF70;
      font-size: 12px;
      display: inline-block;
      max-width: 175px;
    }
    .deliverableDescriptionPlaceholder {
      color: #FFFFFF30;
      font-size: 12px;
    }
  }

  .videoBoxRight {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }
}
.grabbing {cursor: grabbing;}
</style>
